import { Button, ButtonGroup, Modal, PrimaryButton } from "@nulogy/components";
import useConfirmDefaultAvailabilityChangesModal from "hooks/state/useConfirmDefaultAvailabilityChangesModal";
import React, { useRef } from "react";

export default function ConfirmDefaultAvailabilityChangesModal() {
  const { close, isOpen } = useConfirmDefaultAvailabilityChangesModal();
  const submitButton = useRef();

  const submit = () => {
    submitButton.current.click();
  };

  const footerContent = (
    <ButtonGroup>
      <PrimaryButton data-testid="save-in-confirmation" onClick={submit} type="submit">
        Save and apply to schedule
      </PrimaryButton>
      <Button onClick={close}>Cancel</Button>
    </ButtonGroup>
  );

  return (
    <>
      <input ref={submitButton} style={{ display: "none" }} type="submit" />
      <Modal
        ariaHideApp={false}
        footerContent={footerContent}
        isOpen={isOpen}
        onRequestClose={close}
        title="Changing default availability"
      >
        The changes made to default availability will impact the schedule’s past, present, and future availability.
        <br />
        <br />
        Blocks scheduled in the past will not be moved, but may overlap with the unavailable slots.
      </Modal>
    </>
  );
}
